import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { AmIconModule } from '@armor/material';
import { IntroComponent } from './intro/intro.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    RouterModule,
    AmIconModule,
    MatListModule,
  ],
  declarations: [IntroComponent],
  exports: [IntroComponent],
})
export class DesignSystemDocsContentModule {}
